import React from 'react';
import { EventHomeComponentInterface, UiComponentElementInterface } from '../../../../../interfaces/pagebuilder';
import { TitleAndDescription } from '../../../pageBuilder/TitleAndDescription';
import EventHome from '../EventHome';

const EventHomeComponent = ({ uiComponent }: UiComponentElementInterface<EventHomeComponentInterface>) => {
  return (
    <>
      <TitleAndDescription component={uiComponent!} />
      <div
        className={`w-full pb-4 pt-4 max-w-full overflow-x-auto`}
        style={{
          color: uiComponent?.styling?.textColor || '#000',
        }}>
        <EventHome
          title={uiComponent?.title}
          emptyMessage={uiComponent?.emptyMessage || ''}
          bannerColor={uiComponent?.customStyling?.bannerColor}
          titleColor={uiComponent?.customStyling?.titleColor}
          showDefaultTexts={uiComponent?.showDefaultTexts}
          hideSideTexts={uiComponent?.hideSideTexts}
          showPresentationTickets={uiComponent?.showPresentationTickets}
        />
      </div>
    </>
  );
};

export default EventHomeComponent;
